const createAnimationUploadVideoStatusSelector = (
    state: sage.state.IRedux
): sage.status.UploadVideoFileStatus =>
    state.createAnimation.uploadVideoFileStatus;

export default createAnimationUploadVideoStatusSelector;
